import React from "react";
import styled from "styled-components";
import { Flex } from "../Flex";

const StyledChartWrapper = styled(Flex).attrs({
    flex: 1,
    direction: "column",
    position: "relative"
})`
    border-top: 2px solid #d5dcea;
    border-bottom: 2px solid #d5dcea;
`;

const StyledChartGrid = styled(Flex).attrs({
    flex: 1
})`
    &:not(:first-child) {
        border-top: 1px dashed #D5DCEA;
`;

const StyledBarChartContent = styled(Flex).attrs({
    height: "100%",
    width: "100%",
    position: "absolute",
    align: "flex-end"
})`
    padding: 10px 10px 0px;
    top: 0;
    left: 0;
`

const StyledBar = styled(Flex).attrs(({ height }) => ({
    flex: 1,
    height: height,
    margin: { right: "5px" },
    background: "#E0E8F9"
}))`
    border-radius: 4px 4px 0 0;
`;

const StyledBlinkBackground = styled.span`
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(-45deg, transparent 25%, rgba(256, 256, 256, .5) 28%, rgba(256, 256, 256, .5) 30%, transparent 35%);
    background-size: 400% 100%;
    animation: loading 3s ease 0s infinite normal none;

    @-webkit-keyframes loading {
        0% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0 50%;
        }
    }

    @keyframes loading {
        0% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0 50%;
        }
    }
`;


const LoadingBarChart = () => {
    const heights = [115, 140, 143, 101, 138, 135, 133, 98, 171, 180, 173, 130, 99, 142, 91, 88, 93, 76, 97, 127, 131, 118, 118, 151, 148, 174, 146, 139 ];

    return(
        <StyledChartWrapper>
            {Array.from(Array(4).keys()).map((row, idx) =>
                <StyledChartGrid key={`chart-row-${idx}`} />
            )}
            <StyledBarChartContent>
                {Array.from(Array(28).keys()).map((row, idx) =>
                    <StyledBar
                        key={`chart-bar-${idx}`}
                        height={heights[idx] + "px"}
                    />
                )}
            </StyledBarChartContent>
            <StyledBlinkBackground />
        </StyledChartWrapper>
    )
};

export { LoadingBarChart };